//import setActiveRoom from './setActiveRoomActions'
import 'url-search-params-polyfill'
import {getEndpointByHotelCode} from "../utilities/property/getClientIdByHotelCode";

export const REQUEST_PROMO_BEGIN   = 'REQUEST_PROMO_BEGIN'
export const REQUEST_PROMO_SUCCESS = 'REQUEST_PROMO_SUCCESS'
export const REQUEST_PROMO_UPDATE  = 'REQUEST_PROMO_UPDATE'
export const REQUEST_PROMO_FAILURE = 'REQUEST_PROMO_FAILURE'

export const requestPromoBegin = () => ({
	type: REQUEST_PROMO_BEGIN,
})

export const requestPromoSuccess = availability => ({
	type: REQUEST_PROMO_SUCCESS,
	payload: availability
})

export const requestPromoUpdate = availability => ({
	type: REQUEST_PROMO_UPDATE,
	payload: availability
})

export const requestPromoError = error => ({
	type: REQUEST_PROMO_FAILURE,
	payload: { error }
})

// Handle Availability Fetch & Functionality
export default function requestPromoRateData(urlData, roomTypeCode, ratePlanCode, promoCode) {
	return dispatch => {
		let currentEndpointUrl = getEndpointByHotelCode(urlData.hotelCode);

		// URL Params
		let promoQueryParams = {
			startDate: urlData.startDate,
			endDate: urlData.endDate,
			adults: urlData.adults,
			children: urlData.children,
			hotelCode: urlData.hotelCode,
			roomTypeCode: roomTypeCode,
			ratePlanCode: ratePlanCode,
			promoCode: promoCode,
			pricingMethod: urlData.pricingMethod,
			primaryLangId: urlData.primaryLangId,
			exactMatchOnly: true
		}

		// Fetch query string method
		const requestPromoQuery = new URLSearchParams()

		// Loop params for blank values
		for (let key in promoQueryParams) {
			if (typeof promoQueryParams[key] === "undefined") continue
			requestPromoQuery.append(key, promoQueryParams[key])
		}

		// Combine API URL & formatted enhancementUrlParams
		const requestPromoResult = currentEndpointUrl + '/api/hotel/avail?' + requestPromoQuery.toString()

		dispatch(requestPromoBegin())
		return fetch(requestPromoResult)
			.then(handleRequestPromoErrors)
			.then(response => response.json())
			.then((data) => {
				// Store promo data for reference
				dispatch(requestPromoSuccess(data))

				// Update state if null
				if (!data.warnings) {
					const promoAvailability = data.roomStays.map(availability => {
						return availability
					})

					dispatch(requestPromoUpdate(promoAvailability))
				}
			})
			.catch(error => dispatch(requestPromoError(error)))
	}
}

// Handle HTTP errors for Availability
function handleRequestPromoErrors(response) {
	if (!response.ok) {
		throw Error(response.statusText)
	}
	return response
}


// WEBPACK FOOTER //
// ./src/actions/requestPromoActions.js